import React, { RefObject, useMemo } from 'react'
import { Form, Input as InputAntd } from 'antd'
import { InputProps } from 'antd/lib/input'
import { FormItemProps } from 'antd/lib/form'
import dp from 'dot-prop-immutable'

import { useT } from 'src/core/hooks/use-translation'

type Props = InputProps &
  Pick<FormItemProps, 'label' | 'required'> & {
    formikProps: any
    innerRef?: RefObject<InputAntd>
  }

function Input({
  formikProps,
  innerRef,
  label,
  name,
  onChange,
  placeholder,
  required = true,
  size = 'large',
  ...props
}: Props) {
  const { t } = useT()
  const error = useMemo(() => {
    return dp.get(formikProps.errors, name)
  }, [formikProps.errors, name])

  const touched = useMemo(() => {
    return dp.get(formikProps.touched, name)
  }, [formikProps.touched, name])

  const value = useMemo(() => {
    return dp.get(formikProps.values, name)
  }, [formikProps.values, name])

  return (
    <Form.Item
      colon={false}
      hasFeedback={required}
      help={touched && typeof error === 'string' ? t(error) : ''}
      label={t(label)}
      required={required}
      validateStatus={
        error && touched ? 'error' : !error && touched ? 'success' : ''
      }
    >
      <InputAntd
        {...props}
        allowClear={!required}
        name={name}
        onBlur={formikProps.handleBlur}
        onChange={value => {
          formikProps.handleChange(value)
          onChange && onChange(value)
        }}
        placeholder={t(placeholder)}
        ref={innerRef}
        size={size}
        value={value}
      />
    </Form.Item>
  )
}

export default Input
